export default {
    "fit": "fit",
    "flip": "flip"
};
